export default __webpack_public_path__ + "static/media/logo-header.7d3bbf89.png";